<template>
   <CardUploadFiles
      :isVisiblePrimary="false"
      :titleCard="'Precisamos verificar seu RENAVAM'"
      :cardDescription="'renavam'"
      :textCard="'RENAVAM'"
      :textCardAttention="'O documento precisa estar no nome do titular'"
      :srcExampleImage="IconDocument"
      :nextRoute="'SavedDocumentationsFiles'"
      :previewScreen="'PreviewDocumentationFiles'"
   />
</template>
<script>
import CardUploadFiles from '../../components/CardUploadFiles.vue'
import FooterButton from '../../components/FooterButton.vue';
import IconDocument from '../../../../public/images/illustration-document.svg'

export default {
components: {
   CardUploadFiles,
   FooterButton
},
setup() {
   return {
       IconDocument
   };
 },
}
</script>